@if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM)) {
  <form (ngSubmit)="onLink()"
    [formGroup]="form"
    class="mb-4"
    >
    <h4>{{'ITEM.DETAIL.LINK_NEW_ITEM' | translate}}</h4>
    <div class="d-flex align-items-center gap-2">
      <mat-form-field appearance="outline"
        class="form-field-condensed">
        <mat-label>{{'COMMON.LABEL.INVENTORY' | translate}}</mat-label>
        <input matInput
          formControlName="inventory">
      </mat-form-field>
      <button mat-raised-button
        color="primary"
        [disabled]="!form.valid"
        type="submit">
        {{'COMMON.LABEL.CREATE_LINK' | translate}}
      </button>
    </div>
  </form>
}

@if (selectedItem.links?.length) {
  <div class="items-list"
    >
    <h4>{{'ITEM.DETAIL.LINKED_ITEMS' | translate}}</h4>
    @for (item of selectedItem.links; track item) {
      <mpa-linked-item-row
        [item]="item"
      (removeLink)="onRemoveLink($event)"></mpa-linked-item-row>
    }
  </div>
}

@if (!selectedItem?.links?.length) {
  <h4>{{'ITEM.DETAIL.EMPTY_ITEM_LINKS' | translate}}</h4>
}